module.exports = __webpack_public_path__ + "img/logo-clementeballen.ce531ede.png";